module.exports = __webpack_public_path__ + "img/Ic_Professional-Installation.0dc1688b.svg";